import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";
import { toast } from "react-toastify";

interface IParams {
  tenant: ITenant;
}

const MainNavBarTitle: React.FC<IParams> = ({ tenant }) => {
  const rootStore = useContext(RootStoreContext);
  const { attendingMeeting  , canViewSurveys} = rootStore.playerStore;
  const { theme } = rootStore.commonStore;
  const { currentTenant, canViewODG } = rootStore.tenantStore;
 const{setSurveyParameters}= rootStore.surveyStore
     
  useEffect(() => {
    if (!canViewODG &&canViewSurveys && attendingMeeting) setSurveyParameters(attendingMeeting.id);
    return () => {};
  }, [attendingMeeting]);
  return (
    <>
      {attendingMeeting && tenant ? (
        <>
          <strong
            className={classNames(
              theme!.headerTextColor,
              "d-none d-lg-inline-block"
            )}
          >
            {tenant && tenant.name} -
          </strong>
          <span> </span>
          {canViewODG ? 
          (
            <Link to={`${currentTenant!.path}/meeting/${attendingMeeting.id}`}>
            <strong
              className={classNames(
                theme!.headerTextColor,
                "MainNavbarMeetingName"
              )}
            >
              {attendingMeeting.title}
              <i className="fas fa-list ml-2"></i>
            </strong>
          </Link>) :
           (<>
             {attendingMeeting.title}
           
           </>)}
         
        </>
      ) : (
        <>
          <strong className={classNames(theme!.headerTextColor)}>
            {tenant && tenant.name}
          </strong>
        </>
      )}
    </>
  );
};

export default observer(MainNavBarTitle);
